<template>
    <div class="four-side-css-props text-center">
        <div>
        </div>
        <div>

            <div class="btnGroup" >
                <btn :key="index" v-for="(group,index) in groups" :icon="group.icon" s="xs" :active="currentGroup === index" @press="currentGroup = index" />
            </div>
            <div style="border:1px solid lightgrey;text-align:center;display:inline-block;">
                <table>
                    <tbody>
                        <tr>
                            <td>
                            	

                            </td>
                            <td>
                                <drag-input 
                                	:value='styleJSON.paddingTop.value' 
                                	icon="caret-up"
                                	@input="(value)=>{
                                		setStyle({paddingTop:{value, unit:'px'}});
                                		if(currentGroup === 1){
                                			setStyle({paddingBottom:{value, unit:'px'}});
                                		}
                                		if(currentGroup === 2 ){
                                			setStyle({
                                				paddingLeft:{value, unit:'px'},
                                				paddingBottom:{value, unit:'px'},
                                				paddingRight:{value, unit:'px'}
                                			});
                                		}
                                	}" 
                                />
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>
                                <drag-input 
                                	:value='styleJSON.paddingLeft.value' 
                                	icon="arrows-h" 
                                	@input="(value)=>{
                                		setStyle({paddingLeft:{value, unit:'px'}});
                                		if(currentGroup === 1){
                                			setStyle({paddingRight:{value, unit:'px'}});
                                		}
                                		if(currentGroup === 2 ){
                                			setStyle({
                                				paddingTop:{value, unit:'px'},
                                				paddingBottom:{value, unit:'px'},
                                				paddingRight:{value, unit:'px'}
                                			});
                                		}
                                	}" 
                                />
                            </td>
                            <td>
                            <div style="border:1px dashed grey;padding:16px 26px; display:inline-block;">
                            </div>
                            </td>
                            <td >
                                <drag-input 
                                	:value='styleJSON.paddingRight.value' 
                                	icon="arrows-h" 
                                	@input="(value)=>{
                                		setStyle({paddingRight:{value, unit:'px'}});
                                		if(currentGroup === 1){
                                			setStyle({paddingLeft:{value, unit:'px'}});
                                		}
                                		if(currentGroup === 2 ){
                                			setStyle({
                                				paddingLeft:{value, unit:'px'},
                                				paddingBottom:{value, unit:'px'},
                                				paddingTop:{value, unit:'px'}
                                			});
                                		}
                                	}"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <drag-input 
                                	:value='styleJSON.paddingBottom.value' 
                                	icon="arrows-v" 
                                	@input="(value)=>{
                                		setStyle({paddingBottom:{value, unit:'px'}});
                                		if(currentGroup === 1){
                                			setStyle({paddingTop:{value, unit:'px'}});
                                		}
                                		if(currentGroup === 2 ){
                                			setStyle({
                                				paddingLeft:{value, unit:'px'},
                                				paddingRight:{value, unit:'px'},
                                				paddingTop:{value, unit:'px'}
                                			});
                                		}

                                	}" 
                                />
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "four-side-css-props",
    data() {
        return {
            groups: [{
                icon: 'arrows',
                props: [
                    { name: "paddingLeft", icon: "angle-left" },
                    { name: "paddingRight", icon: "angle-right" },
                    { name: "paddingTop", icon: "angle-up" },
                    { name: "paddingBottom", icon: "angle-down" }
                ]
            }, {
                icon: 'arrows-h',
                props: [
                    { name: "paddingLeft", icon: "arrows-h" },
                    { name: "paddingRight", icon: "arrows-v" }
                ]
            }, {
                icon: 'dot-circle-o',
                props: [
                    { name: "paddingLeft", icon: "arrows" }
                ]
            }],
            currentGroup: 0
        }
    },
    props: {
        prop: String,
        title: String,
        setStyle: Function,
        styleJSON: Object,
        dirs: {
            type: Array,
            default () {
                return [
                    { name: "Left", icon: "angle-left" },
                    { name: "Right", icon: "angle-right" },
                    { name: "Top", icon: "angle-up" },
                    { name: "Bottom", icon: "angle-down" },
                ]
            }
        }
    }
}
</script>
<style scoped>
.btnGroupVertical .btn {
    width: 18px;
}
</style>